import React from "react";

export default function SearchImg() {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 15.8236C12.8486 15.8236 15.8333 12.8388 15.8333 9.1569C15.8333 5.475 12.8486 2.49023 9.16667 2.49023C5.48477 2.49023 2.5 5.475 2.5 9.1569C2.5 12.8388 5.48477 15.8236 9.16667 15.8236Z"
          stroke="#64748B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 17.4906L14.1667 14.1572"
          stroke="#64748B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
